import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: '顧問契約の最低期間はありますか?',
      answer: '最低契約期間は6ヶ月となっております。補助金の申請から採択、報告までのサイクルを考慮した期間設定となっています。6ヶ月以降は1ヶ月単位で更新可能です。'
    },
    {
      question: 'LP制作だけ依頼することは可能ですか?',
      answer: 'はい、可能です。LP制作のみのご依頼も承っております。ただし、補助金と連動したLP制作の場合、顧問契約プランの方が大幅に割引価格でご利用いただけます。'
    },
    {
      question: '補助金の採択率はどのくらいですか?',
      answer: '制度や申請内容によって異なりますが、当社の平均採択率は約75%です。事前の診断とヒアリングを丁寧に行い、採択可能性の高い制度を優先的にご提案しています。'
    },
    {
      question: '対応エリアは神奈川・東京のみですか?',
      answer: '主な対応エリアは神奈川県・東京都ですが、オンラインでのサポートであれば全国対応可能です。地域特有の補助金制度については、神奈川・東京が最も得意としています。'
    },
    {
      question: '成功報酬はいつ支払うのですか?',
      answer: '補助金が実際に入金された後のお支払いとなります。採択されても入金前に費用が発生することはありませんので、ご安心ください。'
    },
    {
      question: '法務相談はどこまで対応してもらえますか?',
      answer: '契約書の作成・チェック、内容証明の作成、各種許認可の相談など、行政書士の業務範囲内で幅広く対応いたします。訴訟案件など弁護士業務が必要な場合は、信頼できる弁護士をご紹介いたします。'
    }
  ];

  return (
    <section id="faq" className="py-24 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
            <span className="text-blue-900">よくある質問</span>
          </h3>
          <p className="text-lg text-gray-600">お客様からよくいただくご質問</p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-all"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 flex items-center justify-between gap-4 text-left cursor-pointer hover:bg-gray-50 transition-colors"
              >
                <div className="flex items-start gap-4 flex-1">
                  <div className="w-8 h-8 bg-gradient-to-br from-blue-900 to-blue-700 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <span className="text-white font-bold text-sm">Q</span>
                  </div>
                  <h4 className="text-lg font-bold text-gray-900 flex-1">{faq.question}</h4>
                </div>
                <i className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-2xl text-gray-400 flex-shrink-0`}></i>
              </button>

              {openIndex === index && (
                <div className="px-6 pb-5">
                  <div className="flex items-start gap-4 pl-12">
                    <div className="flex-1">
                      <div className="flex items-start gap-3">
                        <div className="w-8 h-8 bg-gradient-to-br from-orange-500 to-orange-600 rounded-full flex items-center justify-center flex-shrink-0">
                          <span className="text-white font-bold text-sm">A</span>
                        </div>
                        <p className="text-gray-700 leading-relaxed flex-1 pt-1">{faq.answer}</p>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-4">その他のご質問がございましたら、お気軽にお問い合わせください。</p>
          <button 
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-900 to-blue-700 text-white px-8 py-3 rounded-lg font-bold hover:shadow-lg transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-question-answer-line"></i>
            お問い合わせはこちら
          </button>
        </div>
      </div>
    </section>
  );
}
